/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Segment_Event_Group_Option_LabelInputs */



/**
* | output |
* | --- |
* | "Segmentation Option" |
*
* @param {Segment_Event_Group_Option_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const segment_event_group_option_label = /** @type {((inputs?: Segment_Event_Group_Option_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Segment_Event_Group_Option_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Option de segmentation")
	if (locale === "de") return /** @type {LocalizedString} */ ("Segmentierungsoption")
	if (locale === "it") return /** @type {LocalizedString} */ ("Opzione di segmentazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вариант сегментации")
	if (locale === "es") return /** @type {LocalizedString} */ ("Opción de segmentación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("细分选项")
	if (locale === "ja") return /** @type {LocalizedString} */ ("セグメンテーションオプション")
	if (locale === "hi") return /** @type {LocalizedString} */ ("विभाजन विकल्प")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Opção de Segmentação")
	return /** @type {LocalizedString} */ ("Segmentation Option")
});